module.exports = __webpack_public_path__ + "img/10-1_02.566f5c27.jpg";